module.exports = __webpack_public_path__ + "static/media/ios-help-circle.c7cd8d69.svg";